import { SchemaType } from '../type';
export const schema = {
    id: 'workflow',
    name: '审批流',
    type: SchemaType.Indivisible,
    identityField: 'name',
};
